import {
  SEARCH_CREATE,
  SEARCH_READ,
  SEARCH_UPDATE,
  SEARCH_DELETE
} from '../actions/search';

export default function (state = {}, { type, payload }) {
  switch (type) {
    case SEARCH_DELETE:
      return {};
    case SEARCH_READ:
      return payload;
    case SEARCH_UPDATE:
      return payload;
    case SEARCH_CREATE:
      return payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/search.js